/** Dados dos KPIs de faturamento */
export class Faturamento {
    quantidade: number;
    peso: number;
    valor: number;
    percParticipacao: number;

    constructor(props: Partial<Faturamento>) {
        Object.assign(this, props);
    }

    /**
     * Cria o objeto através do JSON informado
     *
     * @param json JSON com as propriedades para criar o objeto
     * @returns objet criado
     */
    static fromJSON(json: string): Faturamento {
        return new Faturamento(JSON.parse(json));
    }
}
